import {
  AdminInput,
  Button,
  Div,
  ErrorToast,
  Modal,
  PropsModal,
  SuccessToast,
  updateLocationConfig,
  reportError,
} from '@vgrubs/components';
import {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { LocationEntity } from 'components/src/types/location.types';
import { ImageInput, ImageWithDownload } from './ImageInput';

export const BankEdit = ({
  modalIsOpen,
  closeModal,
  setLoading,
  setData,
  data,
}: PropsModal & {
  modalIsOpen: boolean | LocationEntity | null;
  setLoading: Dispatch<SetStateAction<boolean>>;
  setData: Dispatch<SetStateAction<LocationEntity | null>>;
  data: LocationEntity | null;
}) => {
  const [lastEin, setLastEin] = useState('');
  const [lastBank, setLastBank] = useState('');

  useEffect(() => {
    if (data) {
      setLastEin(data.configuration.einLast4 || '');
      setLastBank(data.configuration.bankAccountLast4 || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalIsOpen]);

  async function handleConfig() {
    if (!data) return;
    const configuration = {
      einLast4: lastEin,
      bankAccountLast4: lastBank,
    };

    try {
      setLoading(true);
      const res = await updateLocationConfig(data.id, configuration);

      setData((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          configuration,
        };
      });
      SuccessToast(res.data.message);
      closeModal?.();

      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  function handleSubmit(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();

    if (!lastEin) return ErrorToast('Please enter Last 4 EIN');
    if (!lastBank) return ErrorToast('Please enter Last 4 Bank');

    handleConfig();
  }

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header="Edit Bank Details"
      footer={
        <>
          <ImageInput data={data} setData={setData} setLoading={setLoading}>
            <Button $selected $gray $w="100%" $mtSM="30">
              Upload New Voided Check
            </Button>
          </ImageInput>

          <Button
            $selected
            $w="100%"
            $mt="20"
            $mtSM="16"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </>
      }
    >
      <>
        <Div $flex $column $gap="24px" $mb="32">
          <AdminInput
            label="Last 4 EIN"
            placeholder="Enter here"
            value={lastEin}
            onChange={(e) => setLastEin(e.target.value)}
            $textCenter
          />

          <AdminInput
            label="Last 4 Bank"
            placeholder="Enter here"
            value={lastBank}
            onChange={(e) => setLastBank(e.target.value)}
            $textCenter
          />
        </Div>
        <Div $flex $column $gap="24px" $gapSM="20px" $width="100%">
          {data?.images?.map((img, i) => {
            return <ImageWithDownload src={img.url} key={i} />;
          })}
        </Div>
      </>
    </Modal>
  );
};
